$(function() {
    if (!$("body").hasClass("website-state-edit")) {
        var galleryItems = $(".gallery-item");
        galleryItems.each((i, galleryItem) => {
            var img = $("img", galleryItem);
            let imgUrl = img.data("src").split("?")[0];
            var link = $('<a href="' + imgUrl + '" target="_blank"></a>');
            $(img).wrap(link);
        });
    }
});
